import axios from 'axios'
import store from '@/store'

// 搜索
export let getSearch = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/cmsApi/searchAllFormWeb',data
  )
}

// 内页大图
export let getBanner = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/cmsApi/cmsArticleListBySlider',data
  )
}

// 单页 + 列表
export let getSingle = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/cmsApi/cmsArticleListByCms',data
  )
}
// 详情：id
export let getDetail = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/cmsApi/cmsArticleByID',data
  )
}

// 藏品分类
export let getGoodsType = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showApi/getGoodsType',data
  )
}
export let getGoodsTypeVer2 = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showApi/getGoodsTypeVer2',data
  )
}

// 基本陈列 常规展厅
export let listShowRoom = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showApi/listShowRoom',data
  )
}
// 基本陈列 常规展厅详情：id
export let getShowRoom = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showApi/getShowRoom',data
  )
}


// 临时展厅
export let listShowtem = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showtemApi/listShowTem',data
  )
}
// 临时展厅详情：id
export let getShowtem = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showtemApi/getShowTem',data
  )
}


// 展品
export let listShowGoods = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showApi/listShowGoods',data
  )
}
// 展品详情：id
export let getShowGoods = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showApi/getShowGoods',data
  )
}

// 活动
export let listShowHd = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showhdApi/listShowHd',data
  )
}
// 活动详情：id
export let getShowHd = (data)=> {
  return axios.post(
    store.getters.urlApi+'/api/showhdApi/getShowHd',data
  )
}

/////////////////////////////////////// 以下是模拟接口
// 导航
export let getMenu = ()=> {
  return axios.get('/api/home/getMenu')
}
export let getMenuEn = ()=> {
  return axios.get('/api/home/getMenuEn')
}
// 内页大图
// export let getBanner = ()=> {
//   return axios.get('/api/home/getBanner')
// }
// 基本陈列
export let getExhibitionA1 = (data)=> {
  return axios.post('/api/home/getExhibitionA1',data)
}
export let getExhibitionA1Detail = (data)=> {
  return axios.post('/api/home/getExhibitionA1Detail',data)
}
// 特别展览
export let getExhibitionA2 = (data)=> {
  return axios.post('/api/home/getExhibitionA2',data)
}
export let getExhibitionA2Detail = (data)=> {
  return axios.post('/api/home/getExhibitionA2Detail',data)
}
// 冠军故事
export let getExhibitionA4 = (data)=> {
  return axios.post('/api/home/getExhibitionA4',data)
}
export let getExhibitionA4Detail = (data)=> {
  return axios.post('/api/home/getExhibitionA4Detail',data)
}
// 藏品展示
export let getCollectionA1 = (data)=> {
  return axios.post('/api/home/getCollectionA1',data)
}
export let getCollectionA1Detail = (data)=> {
  return axios.post('/api/home/getCollectionA1Detail',data)
}
// 影音资料
export let getCollectionA2 = (data)=> {
  return axios.post('/api/home/getCollectionA2',data)
}
// 活动信息
export let getActivityA1 = (data)=> {
  return axios.post('/api/home/getActivityA1',data)
}
export let getActivityA1Detail = (data)=> {
  return axios.post('/api/home/getActivityA1Detail',data)
}
// 教育新闻
export let getExploreA1 = (data)=> {
  return axios.post('/api/home/getExploreA1',data)
}
export let getExploreA1Detail = (data)=> {
  return axios.post('/api/home/getExploreA1Detail',data)
}
// 学术资讯
export let getExploreA2 = (data)=> {
  return axios.post('/api/home/getExploreA2',data)
}
export let getExploreA2Detail = (data)=> {
  return axios.post('/api/home/getExploreA2Detail',data)
}

// 举重历史
export let getExploreA3 = (data)=> {
  return axios.post('/api/home/getExploreA3',data)
}
export let getExploreA3Detail = (data)=> {
  return axios.post('/api/home/getExploreA3Detail',data)
}

// 通知公告
export let getNewsA1 = (data)=> {
  return axios.post('/api/home/getNewsA1',data)
}
export let getNewsA1Detail = (data)=> {
  return axios.post('/api/home/getNewsA1Detail',data)
}

// 资讯动态
export let getNewsA2 = (data)=> {
  return axios.post('/api/home/getNewsA2',data)
}
export let getNewsA2Detail = (data)=> {
  return axios.post('/api/home/getNewsA2Detail',data)
}
// 党建动态
export let getMuseumAffairsA3 = (data)=> {
  return axios.post('/api/home/getMuseumAffairsA3',data)
}
export let getMuseumAffairsA3Detail = (data)=> {
  return axios.post('/api/home/getMuseumAffairsA3Detail',data)
}

/////////////////////////////cxj
// 获取访问安全码
export let getTokenCode = ()=> {
  return axios.get(store.getters.urlApi+'/api/bookingApiWeb/getTokenCode')
}

// 生成验证码并发送给邮件
export let getEmailValidCode = (data)=> {
  return axios.post(store.getters.urlApi+ '/api/bookingApiWeb/getEmailValidCode',data)
}
// 通过邮箱及验证码预订
export let bookingByEmailValidCode = (data)=> {
  return axios.post(store.getters.urlApi+'/api/bookingApiWeb/bookingByEmailValidCode',data)
}



// WEBPACK FOOTER //
// ./src/api/index.js